import React from "react";
import { Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { SelfStatusCellProps } from "../selfStatusCell";
import { RaterStatusCellProps } from "../raterStatusCell";
import { ScoringStatusCellProps } from "../scoreStatusCell";

interface BaseLegendTableProps {
    statusCellType: React.ElementType<
        SelfStatusCellProps | RaterStatusCellProps | ScoringStatusCellProps
    >;
    data: {
        cellData: SelfStatusCellProps | RaterStatusCellProps | ScoringStatusCellProps;
        comment: string;
    }[];
    title: string;
}

const BaseLegendTable: React.FC<BaseLegendTableProps> = (props) => {
    const cellWidth = "135px";

    return (
        <div>
            <Typography
                gutterBottom
                sx={{ marginBottom: 3, fontSize: "0.8125rem", fontWeight: "bold" }}
            >
                {props.title}
            </Typography>
            <Table sx={{ marginBottom: 5 }}>
                <TableBody>
                    {props.data.map((item, index) => (
                        <TableRow
                            key={index}
                            sx={{
                                height: "auto",
                                alignItems: "stretch",
                                borderBottom: "1px solid #e0e0e0",
                            }}
                        >
                            <TableCell
                                sx={{
                                    minWidth: cellWidth,
                                    maxWidth: cellWidth,
                                    border: "none",
                                    padding: 2,
                                    paddingLeft: 4,
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    height: "100%",
                                }}
                            >
                                <props.statusCellType {...item.cellData} />
                            </TableCell>
                            <TableCell
                                sx={{
                                    border: "none",
                                    padding: 2,
                                    height: "100%",
                                    width: "100%",
                                }}
                            >
                                {item.comment}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};

export default BaseLegendTable;
